import { onBeforeUnmount, onMounted, ref, Ref } from '@vue/composition-api';
export function useClipboard(domClass: string, text: Ref<string>) {
    const clipboard = ref<any>(null);
    const mainCopyMethod = ref<() => void>();
    onMounted(() => {
        // 针对不支持 navigator clipboard 的浏览器，就用 ClipboardJS 来处理
        if (!navigator.clipboard) {
            const ClipboardJS = require('clipboard');
            clipboard.value = new ClipboardJS(domClass, {
                text: function () {
                    return text.value;
                },
            });
        } else {
            mainCopyMethod.value = () => {
                navigator.clipboard.writeText(text.value);
            };
        }
    });
    onBeforeUnmount(() => {
        clipboard.value?.destroy();
    });
    return { clipboard, mainCopyMethod };
}

